module.exports = __webpack_public_path__ + "img/media1.0aaa2bf7.png";